import React from "react";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQ } from "../mock";
import { Script } from "./Script";

export default function Faq() {
  const go = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="faq" className="bg-white py-24 md:py-32" data-testid="faq-section">
      <div className="container-x grid lg:grid-cols-[0.85fr_1.15fr] gap-12 lg:gap-20">
        <div className="reveal">
          <h2 className="display text-[#0e0e0d] text-4xl sm:text-5xl">
            Na co se klienti{" "}
            <Script color="#0e0e0d" className="text-5xl sm:text-6xl mx-2">
              ptají.
            </Script>
          </h2>
          <p className="text-[#5f5f59] mt-10 max-w-sm">
            Všechno o cenách, termínech a tom, jak spolupráce vypadá v praxi.
          </p>
          <button
            onClick={() => go("#kontakt")}
            data-testid="faq-cta"
            className="btn-ink mt-8 px-6 py-3.5 text-sm"
          >
            Napsat nám <ArrowRight size={16} />
          </button>
        </div>

        <Accordion type="single" collapsible className="reveal w-full border-t border-black/[0.09]">
          {FAQ.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-black/[0.09]">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left text-lg md:text-xl display text-[#0e0e0d] py-6 hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5f5f59] text-base leading-relaxed pb-7 pr-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
